import axios from "axios";
axios.defaults.withCredentials = true;
const url = "https://darundaywebprofile.herokuapp.com/api";

export const sendMessage = (messageFormData) =>
  axios.post(`${url}/sendMessage`, messageFormData);
export const getRequests = () => axios.get(`${url}/getRequests`);

export const setStatus = (data) => axios.put(`${url}/setStatus`, data);
export const statusCount = () => axios.get(`${url}/statusCount`);
export const signIn = (formData) => axios.post(`${url}/signin`, formData);
export const extendSession = (sessionTime) =>
  axios.post(`${url}/extend`, sessionTime);
